import { Fragment, lazy } from 'react'
import { css } from '@emotion/react'
import { SpacingToken } from '@livechat/design-system-react-components'

import { SuspenseWrapper } from '@/components/Suspense/SuspenseWrapper'
import ProcessedMarkdown from './ProcessedMarkdown'
const RawMarkdownRenderer = lazy(() => import('./RawMarkdown/RawMarkdown'))

const markdownWrapperCss = css`
  overflow-wrap: break-word;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: var(${SpacingToken.Spacing4});
    margin-bottom: var(${SpacingToken.Spacing4});
    line-height: unset;
  }

  h4 {
    font-size: 1rem;
  }

  h5 {
    font-size: 0.85rem;
  }

  p {
    margin-top: var(${SpacingToken.Spacing2});
    margin-bottom: var(${SpacingToken.Spacing2});
  }

  ul {
    padding-left: var(${SpacingToken.Spacing5});
    margin-top: var(${SpacingToken.Spacing0});
  }

  br {
    content: '';
    display: block;
    margin-bottom: var(${SpacingToken.Spacing4});
  }
`

interface Props {
  content: string | null
  isRawMarkdown?: boolean
  dataTest?: string
  className?: string
}

export const MarkdownRender = ({
  content,
  isRawMarkdown,
  dataTest,
  className,
}: Props) => {
  if (!content) {
    return null
  }

  if (isRawMarkdown) {
    return (
      <SuspenseWrapper fallback={<Fragment />}>
        <RawMarkdownRenderer
          content={content}
          css={[markdownWrapperCss, className]}
        />
      </SuspenseWrapper>
    )
  }

  return (
    <ProcessedMarkdown
      content={content}
      dataTest={dataTest}
      css={[markdownWrapperCss, className]}
    />
  )
}
